module.exports = __webpack_public_path__ + "WorkSans-Regular.a3d6c7f7606fc33a6ab5.ttf";


//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/src/assets/fonts/Work_Sans/static/WorkSans-Regular.ttf
// module id = ../../../../../src/assets/fonts/Work_Sans/static/WorkSans-Regular.ttf
// module chunks = styles